import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    template: `<div>This component requires extending</div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {

}
